import { render } from "./trading-accounts.vue?vue&type=template&id=933484c6"
import script from "./trading-accounts.vue?vue&type=script&lang=js"
export * from "./trading-accounts.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__